var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-1-2h48v48H-1z","key":0}),React.createElement("path",{"stroke":"#788386","strokeLinecap":"square","strokeWidth":"2","d":"M23 2.979l6.18 12.523L43 17.51l-10 9.747 2.361 13.764L23 34.523l-12.361 6.498L13 27.257 3 17.51l13.82-2.008z","key":1})]));
}

Star.defaultProps = {"width":"46","height":"43","viewBox":"0 0 46 43"};

module.exports = Star;

Star.default = Star;
